import { render } from "./CSSTriangle.vue?vue&type=template&id=3fc4234e&scoped=true&bindings={}"
import script from "./CSSTriangle.vue?vue&type=script&lang=js"
export * from "./CSSTriangle.vue?vue&type=script&lang=js"

import "./CSSTriangle.vue?vue&type=style&index=0&id=3fc4234e&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3fc4234e"

export default script